<template>
  <v-card>
    <v-data-table
      :expanded.sync="expanded"
      fixed-header
      :headers="headers"
      :height="height - tableHeight"
      :items="getGeofences"
      id="geofences__dataTable"
      @item-expanded="scrollToRowExpanded"
      item-key="id"
      :footer-props="{
        itemsPerPageText: 'Zonas por página',
        itemsPerPageOptions: itemsPerPageOptions,
        pageText: `${page} de ${totalPages}`,
        disablePagination: loading
      }"
      :items-per-page.sync="itemsPerPage"
      calculate-widths
      :page.sync="page"
      :loading="loading"
      :loading-text="loadingText"
      :no-data-text="dataMessage"
      sort-by="properties.name"
      ref="geofencesDataTable"
      show-expand
      single-expand
      @update:items-per-page="setAgentsOnGeofences()"
      @update:page="setAgentsOnGeofences()"
      @update:sort-by="setAgentsOnGeofences()"
    >
      <template v-slot:top>
        <div class="card--title">
          <v-toolbar height="51" rounded="lg" flat>
            <v-toolbar-title class="ml-md-6"
              >{{
                $t(
                  'fleet_management.geofences.data_table.labels.data_table_toolbar_title'
                )
              }}
              ({{ totalGeofences }})</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn
              small
              outlined
              @click="doAllGeofencesSelected"
              color="secondary"
              rounded
              class="mr-2"
              v-if="geofencesStorageIsEmpty()"
              :loading="loading"
            >
              {{
                $t(
                  'fleet_management.geofences.data_table.labels.activate_all'
                )
              }}
            </v-btn>
            <v-btn
              v-else
              small
              outlined
              @click="removeAllGeofencesSelected"
              color="secondary"
              rounded
              class="mr-2"
              :loading="loading"
            >
              {{
                $t(
                  'fleet_management.geofences.data_table.labels.disable_all'
                )
              }}
            </v-btn>
            <router-link
              :to="{
                name: 'geofences-createZone',
                params: { zonesList: getGeofences }
              }"
            >
              <v-btn
                id="idBtnZonasAgregar"
                v-if="isAdmin || isAdminSubFleet"
                @click="addGeofencesBtn"
                text
              >
                <SvgIcon class="tertiary--text" iconType="icon_geofence_add" />
                <span class="text-capitalize text-body-2">{{
                  $t(
                    'fleet_management.geofences.data_table.labels.data_table_toolbar_button'
                  )
                }}</span>
              </v-btn>
            </router-link>
          </v-toolbar>
        </div>
      </template>

      <template v-slot:header.hideGeofence="{ header }">
        <span id="idZonasSeleccion" class="ml-4">{{ header.text }}</span>
      </template>
      <template v-slot:header.properties.name="{ header }">
        <span id="idZonasNombre" class="ml-4">{{ header.text }}</span>
      </template>
      <template v-slot:header.geometry.type="{ header }">
        <span id="idZonasForma" class="ml-4">{{ header.text }}</span>
      </template>
      <template v-slot:header.agents="{ header }">
        <span class="ml-4">{{ header.text }}</span>
      </template>

      <template v-slot:item.hideGeofence="{ item, index }">
        <v-row align="center" justify="space-around">
          <v-btn 
            :id="`idBtnZonasSeleccionzona${index}`" 
            @click="showGeofenceRow(item)" text small rounded>
            <SvgIcon
              :class="[activateClassGeofence(item)]"
              iconType="icon_geofences"
            />
          </v-btn>
        </v-row>
      </template>
      <template v-slot:item.properties.name="{ item }">
        <v-tooltip top content-class="secondary white--text">
          <template v-slot:activator="{ on, attrs }">
            <span class="searchable label-links" v-bind="attrs" v-on="on">{{
              sliceName(item.properties.name)
            }}</span>
          </template>
          <span>
            {{ item.properties.name }}
          </span>
        </v-tooltip>
      </template>
      <template v-slot:item.geometry.type="{ item }">
        <SvgIcon class="secondary--text" :iconType="getGeometryIcon(item)" />
      </template>
      <template v-slot:item.agents="{ item }">
        <v-menu
          top
          rounded-xl
          :open-on-hover="item.agents.length"
          :open-on-click="false"
          transition="scale-transition"
          min-width="30px"
          allow-overflow
        >
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-badge
                :content="contentBadge(item.agents)"
                :value="contentBadge(item.agents)"
                color="tertiary"
                overlap
              >
                <SvgIcon class="grey--text" iconType="icon_agents" />
              </v-badge>
            </div>
          </template>
          <v-card max-width="250" class="pl-2 scrollable-card">
            <!-- Contenido del menú -->
            <v-chip-group column v-if="item.agents">
              <v-chip v-for="agent in item.agents" :key="agent" small>
                {{ agent.label }}
              </v-chip>
            </v-chip-group>
          </v-card>
        </v-menu>
      </template>

      <template v-slot:item.data-table-expand="{ item, expand, isExpanded, index }">
        <div class="d-flex align-center">
          <v-menu
            offset-x
            nudge-left="12"
            left
            rounded-xl
            content-class="white pa-1"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :id="`idBtnZonasKebabMenu${index}`"
                v-if="
                  isAdmin ||
                    (item.created_by === currentUser &&
                      item.agents.length === 0)
                "
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <div>
              <v-btn
                id="idBtnZonasEditarZona"
                v-if="
                  isAdmin ||
                    (item.created_by === currentUser &&
                      item.agents.length === 0)
                "
                text
                small
                @click="viewGeofenceDetail(item)"
              >
                <SvgIcon class="tertiary--text" iconType="icon_edit_pen" />
                <span class="text-capitalize text-body-2">
                  {{
                    $t(
                      'fleet_management.geofences.row_expanded.labels.button_edit'
                    )
                  }}
                </span>
              </v-btn>
              <v-btn
                id="idBtnZonasEliminarZona"
                text
                small
                @click="deleteGeofence(item)"
                v-if="
                  isAdmin ||
                    (item.created_by === currentUser &&
                      item.agents.length === 0)
                "
              >
                <v-icon small color="primary" class="mr-1">
                  mdi-trash-can-outline
                </v-icon>
                <span class="text-body-2 text-capitalize">{{
                  $t(
                    'fleet_management.geofences.data_table.labels.button_delete'
                  )
                }}</span>
              </v-btn>
            </div>
          </v-menu>

          <v-icon
            id="idZonasDesplegable"
            v-if="checkType(item)"
            class="v-data-table__expand-icon"
            :class="{ 'v-data-table__expand-icon--active': isExpanded }"
            @click="expand(!isExpanded)"
          >
            mdi-chevron-down
          </v-icon>
        </div>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <RowExpanded :item="item" :isAdmin="isAdmin" />
        </td>
      </template>
    </v-data-table>
    <Dialog
      v-if="showDialog"
      idCancelButton="idBtnZonasNoZonas"
      idSubmitButton="idBtnZonasSiZonas"
      idAcceptButton="idBtnZonasAceptarZonas"
      :showDialog="showDialog"
      :oneButton="dialog.oneButton"
      :text="dialog.text"
      :closeButtonText="dialog.closeButtonText"
      :submitButtonText="dialog.acceptButtonText"
      :oneButtonText="dialog.oneButtonText"
      :type="dialog.type"
      :loading="dialog.loading"
      @cancelButtonPressed="cancelDialog"
      @submitButtonPressed="submitGeofenceDelete"
      @oneButtonAction="cancelDialog"
    />
  </v-card>
</template>

<script>
import { i18n } from '@leapsight/portal'
import { SvgIcon, firebaseServices } from '@leapsight/styleguide'
import { FirebaseTagNames } from '@leapsight/portal'
import RowExpanded from './RowExpanded'
import { GeofencesHelpers } from '@/helpers/mainExports.js'
import { mapActions, mapGetters } from 'vuex'
import Dialog from '@/components/dialog/Dialog'
import Mark from 'mark.js'
import agentsHelpers from '@/helpers/agents/agentsHelpers'
import geofences from '@/views/Geofences.vue'
import store from '@/store'
import geofencesHelpers from '@/helpers/geofences/geofencesHelpers'

export default {
  name: 'GeofencesDataTable',
  components: {
    SvgIcon,
    RowExpanded,
    Dialog
  },
  data() {
    return {
      itemsPerPageOptions: [10, 15],
      page: 1,
      itemsPerPage: 10,
      context: '',
      tableHeight: 50,
      currentUser: localStorage.getItem('user_id'),
      dataMessage: `${i18n.t(
        'fleet_management.geofences.data_table.labels.data_table_no_data'
      )}`,
      dataTableHeight: 0,
      dialog: {
        text: '',
        closeButtonText: i18n.t('general.dialogComponent.closeButtonText'),
        acceptButtonText: i18n.t('general.dialogComponent.acceptButtonText'),
        type: '',
        loading: false,
        oneButton: false,
        oneButtonText: ''
      },
      dialogDefault: {
        text: '',
        closeButtonText: i18n.t('general.dialogComponent.closeButtonText'),
        acceptButtonText: i18n.t('general.dialogComponent.acceptButtonText'),
        type: '',
        loading: false,
        oneButton: false,
        oneButtonText: ''
      },
      expanded: [],
      geofenceToDelete: '',
      headers: [
        {
          text: 'Seleccion',
          value: 'hideGeofence',
          align: 'center',
          class: 'hide-arrow-v-icon',
          id: 'idZonasSeleccion'
        },
        {
          text: i18n.t(
            'fleet_management.geofences.data_table.labels.data_table_header_name'
          ),
          value: 'properties.name',
          align: 'center',
          class: 'secondary--text',
          id: 'idZonasNombre'
        },
        {
          text: i18n.t(
            'fleet_management.geofences.data_table.labels.data_table_header_shape'
          ),
          value: 'geometry.type',
          align: 'center',
          class: 'secondary--text',
          id: 'idZonasForma'
        },
        {
          text: i18n.t(
            'fleet_management.geofences.data_table.labels.data_table_header_agents'
          ),
          value: 'agents',
          align: 'center',
          class: 'secondary--text',
          sortable: false
        },
        {
          text: '',
          value: 'data-table-expand',
          align: 'start'
        }
      ],
      inputTerm: '',
      itemType: '',
      loading: false,
      loadingText: i18n.t(
        'fleet_management.geofences.data_table.labels.loading_text'
      ),
      markInstance: {},
      matchPosition: 1,
      searchMatch: [],
      selected: [],
      showDialog: false,
      geofencesSelectedFm: [],
      isSortingReversed: false
    }
  },
  methods: {
    ...mapActions(['setSearchMatch', 'showGeofences']),
    addGeofencesBtn() {
      firebaseServices.logEvent(
        firebaseServices.analytics,
        FirebaseTagNames.BTN_FLEET_MANAGEMENT_ADD_ZONE
      )
    },
    doAllGeofencesSelected() {
      try {
        this.loading = true

        this.$store.dispatch('doAllGeofencesSelected', value => {
          this.geofencesSelectedFm = value
          return this.geofencesSelectedFm
        })
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async loadGeofenceSelected() {
      try {
        this.loading = true
        const updateFilterGeofence = this.getGeofences.map(geo => {
          if (this.getZonesStorage().includes(geo.id)) geo.hideGeofence = false

          return geo
        })
        this.geofencesSelectedFm = updateFilterGeofence.filter(geofence =>
          this.getZonesStorage().includes(geofence.id)
        )

        this.$store.commit('setFilterGeofencesByString', {
          filterGeofences: updateFilterGeofence
        })

        if (this.showGeofencesOnMap) {
          const promisesGeofencesSelected = []
          const zonesStorage = this.getZonesStorage()
          zonesStorage.forEach(id => {
            promisesGeofencesSelected.push(GeofencesHelpers.getGeofence({ id }))
          })
          const results = await Promise.allSettled(promisesGeofencesSelected)
          this.geofencesSelectedFm = results.map(result => {
            const { value } = result
            Object.assign(value.data, { id: value.id })
            if (Boolean(value)) return value.data
            else return {}
          })

          this.$store.dispatch('destroyGeofencesOnMap')
          GeofencesHelpers.geofenceOnMap(this.geofencesSelectedFm, this.map)
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    getZonesStorage() {
      return JSON.parse(localStorage.getItem('geofencesSelectedFm') ?? '[]')
    },
    removeAllGeofencesSelected() {
      this.geofencesSelectedFm = []
      this.getGeofences.forEach(geonfece => {
        geonfece.hideGeofence = true
      })
      localStorage.setItem('geofencesSelectedFm', '[]')
      this.$store.dispatch('destroyGeofencesOnMap')
      GeofencesHelpers.geofenceOnMap(this.geofencesSelectedFm, this.map)
    },
    activateClassGeofence(item) {
      const activateClass = Boolean(this.getZonesStorage().includes(item.id))
      if (activateClass && !this.showGeofencesOnMap) return 'black--text'
      if (activateClass && this.showGeofencesOnMap) return 'primary--text'
      return 'grey--text'
    },
    async fillGeofenceDataById(geofenceId) {
      try {
        this.loading = true
        const { data } = await GeofencesHelpers.getGeofence({ id: geofenceId })
        const idx = this.getGeofencesSortedByName.findIndex(
          geofence => geofence.id === geofenceId
        )
        Object.assign(this.getGeofencesSortedByName[idx], data)
      } catch (error) {
        const errorText = GeofencesHelpers.getErrorMessageByCode(error.error)
        const snackbar = {
          text: errorText
        }
        store.dispatch('ui/setSnackbar', snackbar)
      } finally {
        this.loading = false
      }
    },
    async showGeofenceRow(value) {
      const id = value.id

      await this.fillGeofenceDataById(id)

      if (!this.showGeofencesOnMap) await this.loadGeofenceSelected()

      if (!this.geofencesSelectedFm.some(geo => geo.id == id)) {
        value.hideGeofence = false
        this.geofencesSelectedFm.push(value)
      } else {
        value.hideGeofence = true
        this.geofencesSelectedFm = this.geofencesSelectedFm.filter(
          geofences => geofences.id != id
        )
      }

      const geofencesId = this.geofencesSelectedFm.map(geofence => geofence.id)
      localStorage.setItem('geofencesSelectedFm', JSON.stringify(geofencesId))
      this.$store.commit('setGeofencesInLocalStorage')

      this.$store.dispatch('destroyGeofencesOnMap')
      GeofencesHelpers.geofenceOnMap(this.geofencesSelectedFm, this.map)
    },
    contentBadge(item) {
      const value = item.length
      return value
    },
    cancelDialog() {
      this.showDialog = false
      Object.assign(this.dialog, this.dialogDefault)
    },
    //if is a circle we show the expansion panel
    checkType(item) {
      const type = GeofencesHelpers.getGeometryType(item)
      return type == 'circle' ? true : false
    },
    deleteGeofence(item) {
      const {
        properties: { name: geofenceName }
      } = item

      this.showDialog = true
      this.dialog.text = i18n.t(
        'fleet_management.geofences.delete_geofence.labels.dialog_text',
        { geofenceName }
      )
      this.dialog.type = 'warning'
      this.dialog.closeButtonText = i18n.t(
        'fleet_management.geofences.delete_geofence.labels.dialog_closeButton'
      )
      this.dialog.acceptButtonText = i18n.t(
        'fleet_management.geofences.delete_geofence.labels.dialog_acceptButton'
      )

      this.geofenceToDelete = item

      this.$store.dispatch('destroyGeofencesOnMap')
    },

    async getAgentsByGeofences() {
      const promisesFillAgentsByGeofence = []
      this.getGeofencesSortedByName
        .slice(
          (this.page - 1) * this.itemsPerPage,
          this.itemsPerPage * this.page
        )
        .forEach(geofence => {
          promisesFillAgentsByGeofence.push(
            agentsHelpers.getAgents(geofence.id, { _p: 'label' })
          )
        })
      return Promise.all(promisesFillAgentsByGeofence)
    },

    async buildAgentsSetByGeofence() {
      const agentsSetByGeofence = []
      const agentsByGeofence = await this.getAgentsByGeofences()
      agentsByGeofence.forEach(result => {
        agentsSetByGeofence.push({
          geofenceId: result.geofenceId,
          agentsSet: result.response.args[0]
        })
      })
      return agentsSetByGeofence
    },

    async setAgentsOnGeofences() {
      this.loading = true
      const agentsByGeofence = await this.buildAgentsSetByGeofence()

      this.getGeofences
        .slice(
          (this.page - 1) * this.itemsPerPage,
          this.itemsPerPage * this.page
        )
        .forEach(item => {
          agentsByGeofence.forEach(obj => {
            if (item.id == obj.geofenceId) item.agents = obj.agentsSet
          })
        })
      this.loading = false
    },

    async fillGeofences() {
      try {
        const response = await GeofencesHelpers.getGeofences()
        if (!response.hasOwnProperty('error')) {
          const zones = response.map(item => {
            item.data.id = item.id
            item.data.agents = []
            item.data.hideGeofence = true
            item.data.created_by = item.created_by
            return item.data
          })

          this.$store.commit('setGeofences', { zones })
          this.$store.commit('resetFilterGeofencesState')

          this.setAgentsOnGeofences()

          this.loading = false
        } else {
          this.loading = false
          this.dataMessage = `${i18n.t(
            'fleet_management.geofences.data_table.labels.data_table_error'
          )}`
        }
      } catch (error) {
        const errorText = GeofencesHelpers.getErrorMessageByCode(error.error)
        const snackbar = {
          text: errorText
        }
        store.dispatch('ui/setSnackbar', snackbar)
        this.loading = false
      }
    },
    getGeometryIcon(item) {
      const type = GeofencesHelpers.getGeometryType(item)
      switch (type) {
        case 'circle':
          return 'icon_geofence_circle'
          break
        case 'polygon':
          return 'icon_geofence_polygon'
          break
      }
    },

    resize() {
      //Columna datatable
      const dataTableColumn = document.getElementById('geofences__dataTable')
        .parentElement.parentElement
      // Alto del div contenedor
      const dataTableColumnHeight = dataTableColumn.offsetHeight

      // Padding total de la columna de la tabla
      const compStylesDataTableColumn = window.getComputedStyle(dataTableColumn)
      const paddingDataTableCol =
        parseInt(compStylesDataTableColumn.getPropertyValue('padding-top')) +
        parseInt(compStylesDataTableColumn.getPropertyValue('padding-bottom'))

      //Alto y margen bottom del componente titulo y buscador
      const marginBottomTitleAndSearch = parseInt(
        window
          .getComputedStyle(document.getElementById('titleAndSearch'))
          .getPropertyValue('margin-bottom')
      )
      const titleAndSearchHeight =
        document.querySelector('#titleAndSearch').offsetHeight +
        marginBottomTitleAndSearch

      // Alto Card Title
      const cardTitleHeight = document.querySelector(
        '#geofences__dataTable .card--title'
      ).offsetHeight

      this.dataTableHeight =
        dataTableColumnHeight -
        paddingDataTableCol -
        titleAndSearchHeight -
        cardTitleHeight
    },
    scrollToRowExpanded(data) {
      //Si la acción es de despliegue, realiza el scroll
      if (data.value) {
        //A vuetifiy le lleva un tiempo añadir las clases de row y expanded
        setTimeout(() => {
          const selectedRow = document.querySelector(
            '.v-data-table__expanded__content'
          ).previousElementSibling
          const tableHeader = document.querySelector('.v-data-table-header')
            .clientHeight
          const barToScroll = document.querySelector(
            '#geofences__dataTable .v-data-table__wrapper'
          )
          selectedRow.scrollIntoView()
          //Despues de llevar el row al top de la vista, scrollea la altura del header
          barToScroll.scrollBy({
            top: -tableHeader,
            behaviour: 'smooth'
          })
        }, 10)
      }
    },
    searchAndHighlight(inputTerm) {
      const keyword = inputTerm
      const marked = this.markInstance?.unmark ? this.markInstance : new Mark()
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const actualThis = this
      this.searchMatch = []

      marked.unmark({
        done: function() {
          marked.mark(keyword, {
            separateWordSearch: false,
            noMatch: function() {
              // Esta funcion se ejecuta cuando no hay match
            },
            each: function(node) {
              // Array con los row que machean a la busqueda
              actualThis.searchMatch.push(node.closest('tr'))
            }
          })
        }
      })

      this.setSearchMatch(this.searchMatch)
      //Damos estilo al match activo si el listado de nodos encontrados es mayor a 0
      const activePosition = document.querySelectorAll('mark')

      if (activePosition.length > 0)
        activePosition[this.matchPosition - 1].classList.add('activeMatch')

      // Scrollintoview para el match activo
      if (this.searchMatch.length > 0) {
        const selectedRow = this.searchMatch[this.matchPosition - 1]
        const dataTablelastRow = document.querySelector(
          '#geofences__dataTable .v-data-table__wrapper table tbody tr:last-child'
        )
        const tableHeader = document.querySelector('.v-data-table-header')
          .clientHeight
        const barToScroll = document.querySelector(
          '#geofences__dataTable .v-data-table__wrapper'
        )

        selectedRow.scrollIntoView()

        // Esta validacion es para hacer referencia al ultimo row ya que por defecto no se visualiza
        if (selectedRow === dataTablelastRow) {
          barToScroll.scrollBy({
            top: 0,
            behaviour: 'smooth'
          })
        } else {
          barToScroll.scrollBy({
            top: -tableHeader,
            behaviour: 'smooth'
          })
        }
      }
    },
    sliceName(value) {
      if (value.length > 20 && this.$vuetify.breakpoint.lgAndDown) {
        const formatedLabel = value.substr(0, 20) + '...'
        return formatedLabel
      }
      return value
    },
    async submitGeofenceDelete() {
      const id = this.geofenceToDelete.id
      try {
        this.dialog.loading = true
        await GeofencesHelpers.deleteGeofence(id)
        const zonesStorage = this.getZonesStorage()
        const updatedZonesStorage = zonesStorage.filter(z => z !== id)
        localStorage.setItem(
          'geofencesSelectedFm',
          JSON.stringify(updatedZonesStorage)
        )

        this.dialog.loading = false
        this.dialog.text = i18n.t('general.dialogComponent.title_success')
        this.dialog.oneButton = true
        this.dialog.oneButtonText = i18n.t(
          'general.dialogComponent.acceptButtonText'
        )
        this.dialog.type = 'success'
        await this.fillGeofences()
        this.setAgentsOnGeofences()
      } catch (error) {
        const { error: codeError } = error
        const errorText = GeofencesHelpers.getErrorMessageByCode(codeError)
        this.dialog.loading = false
        this.dialog.type = 'error'
        this.dialog.text = errorText
        this.dialog.oneButton = true
        this.dialog.oneButtonText = i18n.t(
          'general.dialogComponent.acceptButtonText'
        )
      }
    },
    viewGeofenceDetail(item) {
      firebaseServices.logEvent(
        firebaseServices.analytics,
        FirebaseTagNames.BTN_FLEET_MANAGEMENT_EDIT_ZONE
      )

      this.$router.push({
        name: 'GeofenceDetail',
        params: { id: item.id }
      })
    },
    geofencesStorageIsEmpty() {
      return !Boolean(this.getZonesStorage().length)
    }
  },
  computed: {
    ...mapGetters('auth', ['connection', 'session']),
    ...mapGetters('mapState', ['map']),
    ...mapGetters([
      'getSearchInput',
      'getMatchPosition',
      'isAdmin',
      'isAdminSubFleet',
      'getGeofences',
      'getGeofencesSortedByName',
      'showGeofencesOnMap',
      'getGeofencesOnMap',
      'getGeofenceInLocalStorage',
      'showGeofence'
    ]),
    createdBy() {
      return this.getGeofences.created_by === this.currentUser
    },
    totalPages() {
      return Math.ceil(this.getGeofences.length / this.itemsPerPage)
    },
    height() {
      return this.dataTableHeight
    },
    totalGeofences() {
      return this.getGeofences.length
    }
  },
  async created() {
    this.loading = true
    //Si la sesión de la conexión wamp se encuentra abierta obtengo los datos
    if (this.session.isOpen) {
      await this.fillGeofences()
      await this.loadGeofenceSelected()
    }
  },
  watch: {
    getSearchInput() {
      const keyword = this.getSearchInput
      this.searchAndHighlight(keyword)
      this.setAgentsOnGeofences()
    },
    getMatchPosition() {
      this.matchPosition = this.getMatchPosition
      const keyword = this.getSearchInput
      this.searchAndHighlight(keyword)
    },
    async session(newSession) {
      //En caso que al inicio no hubiera una sesión abierta, observamos su estado
      //y cuando la misma este disponible obtenemos los datos
      //Escenario de uso: frente a un reload de página
      if (newSession.isOpen) await this.fillGeofences()
    },
    async showGeofencesOnMap(value) {
      if (!value) {
        this.geofencesSelectedFm = []
      } else {
        await this.loadGeofenceSelected()
        this.$store.dispatch('destroyGeofencesOnMap')
        GeofencesHelpers.geofenceOnMap(this.geofencesSelectedFm, this.map)
      }
    }
  },
  updated() {
    this.$nextTick(function() {
      this.context = document.querySelectorAll('.searchable')
      this.markInstance = new Mark(this.context)
    })
  },
  mounted() {
    addEventListener('resize', this.resize)
    this.$nextTick(function() {
      this.resize()
    })
  },
  beforeDestroy() {
    removeEventListener('resize', this.resize)
  }
}
</script>
<style lang="scss" scoped>
.scrollable-card {
  max-height: 200px;
  overflow-y: auto;
}
.v-menu__content {
  contain: initial;
  overflow: visible;
}
.v-menu__content::before {
  position: absolute;
  content: '';
  top: 50%;
  right: -12px;
  transform: translateY(-50%);
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
.v-btn.btn__activator-not-focus:not(.v-btn--text):not(.v-btn--outlined):focus:before {
  opacity: 0;
}
span.label-links:hover {
  text-decoration-line: underline;
  color: var(--deep-sky-blue) !important;
}
</style>
<style lang="scss">
#geofences__dataTable {
  .v-toolbar__title {
    font-weight: bold;
    font-size: 0.9375rem;
  }

  mark {
    background-color: var(--yellow-lighten-1);
    &.activeMatch {
      background-color: var(--orange-ligthen-1);
    }
  }
}
</style>
